import React, { useEffect, useState } from "react";
import { getOnlineRegistration } from "../Service/Api";
import { Link } from "react-router-dom";
const OnlineRegistration = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getOnlineRegistration();
        setData(data);
      } catch (error) {
        console.error("Error fetching online registration data:", error);
      }
    };
    fetchData();
  }, []);
  const emptyArray = [];
  return (
    <>
      {data.length > 0 &&
        data.map((item) => (
          <div className="onlineReg">
            <Link to="/howtoapply" target="_blank" rel="noreferrer">
              {item.title}
            </Link>
            {item.attachments.length > 0 && (
              <Link
                to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item?.attachments[0]}`}
                target="_blank"
                rel="noreferrer"
              >
                <i class="bi bi-paperclip"></i>
              </Link>
            )}
          </div>
        ))}
    </>
  );
};
export default OnlineRegistration;
